/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "fe55146db8a9634cea81f3a43e862957d6c26382";
